<template>
  <div id="app" >
    <nav-bar v-bind:localName= "activePage" />
    <router-view/>
    <!-- <div class="section" id="sectionFooter"> -->
           <tab-bar />
    <!-- </div> -->
  </div>
</template>
<script>
import TabBar from './components/common/tabbar/TabBar'
import NavBar from './components/common/navbar/NavBar'
export default {
  name: 'app',
  data () {
    return {
      activePage: ''
    }
  },
  components: {
    NavBar,
    TabBar
  },
  created () {
  }
}
</script>
<style lang="scss">
  @import "assets/css/base.css";
  @import "assets/css/font-awesome.css";
  #app {
    min-width: 900px;
    max-width:100%;
    height: 100%;
    margin: 0;
    padding: 0;
    margin:0;
    display:block;
  }
  #sectionFooter {
    display: block!important;
    width: 100%;
    color: #797a85;
    background: #303848;
    .fp-tableCell {
      display:block !important;
    }
  }
</style>
